import React, { forwardRef } from 'react';

const AttributesAsRowsIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      {...otherProps}
    >
      <path
        d="M10.7502 12H1.25019C0.912282 11.9926 0.591042 11.8517 0.356776 11.6081C0.12251 11.3645 -0.00570349 11.0379 0.000194861 10.7C-0.00570349 10.3621 0.12251 10.0355 0.356776 9.7919C0.591042 9.54827 0.912282 9.40735 1.25019 9.4H10.7502C11.0881 9.40735 11.4093 9.54827 11.6436 9.7919C11.8779 10.0355 12.0061 10.3621 12.0002 10.7C12.0061 11.0379 11.8779 11.3645 11.6436 11.6081C11.4093 11.8517 11.0881 11.9926 10.7502 12ZM12.0002 6.783C12.0058 6.5121 11.9036 6.25006 11.7161 6.05447C11.5286 5.85889 11.2711 5.74577 11.0002 5.74H1.00019C0.731476 5.75177 0.477668 5.8668 0.29168 6.06111C0.105693 6.25542 0.00187856 6.51402 0.00187856 6.783C0.00187856 7.05198 0.105693 7.31058 0.29168 7.50489C0.477668 7.6992 0.731476 7.81423 1.00019 7.826H11.0002C11.2711 7.82023 11.5286 7.70711 11.7161 7.51153C11.9036 7.31594 12.0058 7.0539 12.0002 6.783ZM12.0002 3.392C12.0045 3.18874 11.9279 2.99208 11.7873 2.84526C11.6466 2.69844 11.4535 2.61346 11.2502 2.609H0.750195C0.547111 2.61346 0.354091 2.6983 0.213486 2.84491C0.0728804 2.99151 -0.00382677 3.18791 0.000194861 3.391C-0.00409522 3.59426 0.0724925 3.79092 0.213127 3.93774C0.353761 4.08456 0.546934 4.16954 0.750195 4.174H11.2502C11.4535 4.16954 11.6466 4.08456 11.7873 3.93774C11.9279 3.79092 12.0045 3.59426 12.0002 3.391V3.392ZM12.0002 0.522C12.0017 0.45489 11.9899 0.388151 11.9655 0.325594C11.9412 0.263037 11.9048 0.205888 11.8583 0.157413C11.8119 0.108937 11.7564 0.0700852 11.6949 0.0430758C11.6335 0.0160664 11.5673 0.00142909 11.5002 0H0.500195C0.433085 0.00142909 0.366914 0.0160664 0.305462 0.0430758C0.24401 0.0700852 0.188482 0.108937 0.14205 0.157413C0.0956174 0.205888 0.0591908 0.263037 0.0348508 0.325594C0.0105109 0.388151 -0.00126532 0.45489 0.000194861 0.522C-0.00126532 0.589109 0.0105109 0.655849 0.0348508 0.718406C0.0591908 0.780963 0.0956174 0.838112 0.14205 0.886587C0.188482 0.935063 0.24401 0.973915 0.305462 1.00092C0.366914 1.02793 0.433085 1.04257 0.500195 1.044H11.5002C11.5673 1.04257 11.6335 1.02793 11.6949 1.00092C11.7564 0.973915 11.8119 0.935063 11.8583 0.886587C11.9048 0.838112 11.9412 0.780963 11.9655 0.718406C11.9899 0.655849 12.0017 0.589109 12.0002 0.522Z"
        fill={color}
      />
    </svg>
  );
});

AttributesAsRowsIcon.defaultProps = {
  style: {
    color: 'black',
  },
};

export default AttributesAsRowsIcon;
